import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { CATEGORY_TILES, categoryImageSrc, categoryLabelKey, categorySlug } from '../categories';

export const CategoriesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="categories-page">
      <h2 className="section-title">{t('categories.title')}</h2>
      <div className="category-tile-grid">
        {CATEGORY_TILES.map(cat => (
          <Link
            key={cat}
            to={`/categories/${categorySlug(cat)}`}
            className="category-tile"
            aria-label={t(categoryLabelKey(cat))}
          >
            <img
              className="category-tile-image"
              src={categoryImageSrc(cat)}
              alt=""
              aria-hidden="true"
            />
            <h3 className="category-tile-heading">{t(categoryLabelKey(cat))}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
};
